import { createFileRoute } from '@tanstack/react-router'
import { AdminEmailPage } from '@/features/admin-email'

export const Route = createFileRoute('/admin-email')({
  component: AdminEmailPage,
})
